var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 759.13 123.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7c3aed;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#6f90ff;}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:#003ab8;}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:#5efc82;}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:#009624;}.cls-16{fill:url(#New_Gradient_Swatch_copy);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:#00c853;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 539.65,
    y1: 84.78,
    x2: 564.54,
    y2: 84.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3750d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#003ab8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 528.31,
    y1: 62.41,
    x2: 546.66,
    y2: 62.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6f90ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6c8dfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#6385f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5378e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 530.03,
    y1: 73.47,
    x2: 559.01,
    y2: 73.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2563eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2561e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2559df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#264ccf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2647c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 557.67,
    y1: 62.92,
    x2: 592.23,
    y2: 62.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2a4acb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 531.87,
    y1: 65.66,
    x2: 572.32,
    y2: 65.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5378e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#5076e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#476fdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3763d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2052c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#033cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#003ab8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 536.3,
    y1: 65.69,
    x2: 572.32,
    y2: 65.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5a7ff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#577def"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#4e75e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3e69df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2758d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0a42be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#003ab8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -348.75,
    y1: -881.42,
    x2: -323.85,
    y2: -881.42,
    gradientTransform: "translate(198.71 -813.35) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#007e06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -360.08,
    y1: -903.79,
    x2: -341.74,
    y2: -903.79,
    gradientTransform: "translate(198.71 -813.35) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26d45e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29d660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#43e870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#51f179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4ff078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#46ec74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#38e56d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#25da64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0bce58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#00c853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -358.36,
    y1: -892.73,
    x2: -329.38,
    y2: -892.73,
    gradientTransform: "translate(198.71 -813.35) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00c550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00bc47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ac38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#009624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -330.73,
    y1: -903.28,
    x2: -296.16,
    y2: -903.28,
    gradientTransform: "translate(198.71 -813.35) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#27a636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy",
    x1: -336.3,
    y1: -937.01,
    x2: -336.3,
    y2: -864.07,
    gradientTransform: "translate(198.71 -813.35) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26d45e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26d45e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0caa37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#009624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -334.01,
    y1: -937.01,
    x2: -334.01,
    y2: -864.05,
    gradientTransform: "translate(198.71 -813.35) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3de26b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#3ade67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#30d15c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1fbd48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#08a02d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#009624"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.76.06a11.06,11.06,0,0,1-1.1,19H39v102.6H62.24V19.06h39.43V.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.66,9.53a9.31,9.31,0,0,1-5.05,8.3,9.27,9.27,0,0,1-8.57,0A9.33,9.33,0,0,1,8.57.24h1.52a9.33,9.33,0,0,1,8.57,9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106,63.23c0-13-.18-21.46-.72-29.4h20l.77,17.84h.64c4.64-13.53,15.87-20,26.11-20a21.28,21.28,0,0,1,5.59.54V53.67a32.64,32.64,0,0,0-7.31-.77c-11.88,0-19.44,7.13-21.4,17.38a35.78,35.78,0,0,0-.49,6.12v45.26H106Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260,95.09c0,10.73.28,19.54.72,26.57H240.38l-1-14.62h-.57c-3.79,6.48-13.06,16.79-31,16.79-16,0-33.27-8.77-33.27-39.41V33.83h23.22V80.25c0,15.28,5.39,24.84,18.46,24.84a21,21,0,0,0,19.31-13,17.38,17.38,0,0,0,1.25-6.61V33.83H260Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.79,84.22c.72,14.68,14.1,22.17,29.64,22.17,11.48,0,19.42-1.65,27.07-4.38L362,117.77c-8.2,3.4-19.28,6.06-33.6,6.06-30.47,0-48.69-18-48.69-44.84,0-22.63,15-47.32,46.38-47.32,31.91,0,41.2,25.73,41.2,43.54a40.29,40.29,0,0,1-.88,9Zm43.53-16.08c.08-6.14-3.09-21-20.65-21-15.44,0-21.77,12.49-23,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.91,0l-.29,96.73c0,9.6.28,19.23.72,24.93H454.49l-.95-15.06h-.36c-6,11-17.89,17.23-31.92,17.23C399,123.83,380,106.19,380,79c-.18-29,19.92-47.34,43.35-47.34,13.63,0,23.4,5.45,27.7,12.08h.36L451.69,0ZM451.4,71.42a28.92,28.92,0,0,0-.56-5.91c-2.36-9.06-10.56-16.36-22-16.36-15.84,0-25.24,12.21-25.24,28.68,0,15.68,9.1,27.59,25.06,27.59A22.56,22.56,0,0,0,450.73,88a28.48,28.48,0,0,0,.67-6.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "564.54 86.19 541.08 86.19 539.65 83.36 564.22 83.36 564.54 86.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "546.65 63.83 528.32 63.83 528.67 61 546.4 61 546.65 63.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "559.01 74.88 531.7 74.88 530.03 72.06 558.64 72.06 559.01 74.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M591.53,86.29C584.23,114.2,555,123.66,555,123.66s34.82-15.6,29.2-49.16C577.78,36.25,595.75,66.38,591.53,86.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M568.32,35.08c28.18,17.83,23.74,47.36,23.55,49.05-.49,4.49-2.3,9.22-5.3,8.57s-2.25-5-2.25-5S589.59,54.82,561,42.63c-5.46-2.9-2.65-7.12-2.65-7.12S560.8,30.32,568.32,35.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M568.39,35.11s-7.44-3.7-10.18,1.18c-1.54,3,2.83,6.34,2.83,6.34S550.22,38,542,39.19c-6.92,1-2.37-11.56,9.13-9.83C562.86,31.12,567.93,34.84,568.39,35.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M550.12,29.24S530.52,27.63,531.94,43c0,0-.07,7.74,12.85,19.17,4.15,3.67,9.61,9.13,12.35,11.92,14,14.22,2.4,24.19-1.94,28.07,0,0,13.21-3.33,16.86-18.79,1.5-8.48-3.2-14.49-19.48-29.63C542.86,44.86,533.09,29.11,550.12,29.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M550.12,29.26s-15.53-1.51-13.67,13.39c0,0,.94,7.57,14.39,18.73,4.26,3.53,9.64,9.17,12.38,11.95,14,14.23-3.68,25-8,28.82,0,0,13.21-3.33,16.86-18.78,1.5-8.48-3.2-14.5-19.48-29.63C542.86,44.88,533.09,29.13,550.12,29.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "522.56 66.66 546.02 66.66 547.46 69.49 522.89 69.49 522.56 66.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "540.45 89.03 558.79 89.03 558.43 91.85 540.7 91.85 540.45 89.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "528.09 77.97 555.4 77.97 557.07 80.8 528.47 80.8 528.09 77.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M495.57,66.56c7.3-27.91,36.54-37.37,36.54-37.37s-34.81,15.6-29.19,49.17C509.32,116.61,491.35,86.48,495.57,66.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M518.78,117.77c-28.17-17.83-23.74-47.35-23.55-49,.49-4.49,2.3-9.21,5.31-8.57s2.24,4.95,2.24,4.95S497.51,98,526.06,110.22c5.46,2.91,2.65,7.13,2.65,7.13S526.3,122.53,518.78,117.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M518.72,117.74s7.44,3.71,10.17-1.18c1.54-3-2.83-6.34-2.83-6.34s10.82,4.65,19,3.44c6.93-1,3.74,10.94-8.12,10S519.18,118,518.72,117.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M537,123.61s19.61,1.61,18.18-13.73c0,0,.08-7.73-12.85-19.17-4.14-3.66-9.6-9.13-12.34-11.91-14-14.23-2.41-24.2,1.93-28.07,0,0-13.2,3.33-16.85,18.78-1.51,8.48,3.2,14.5,19.48,29.63C544.24,108,553.91,123.66,537,123.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M537,123.61s15.53,1.54,13.5-12.73c0,0-.76-8.24-14.22-19.41-4.25-3.53-9.64-9.17-12.38-12-14-14.22,3.68-24.94,8-28.82,0,0-13.2,3.33-16.85,18.79C513.54,78,518.25,84,534.53,99.12,544.24,108,554,123.75,537,123.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.74.07V33.83h22.49V51.24H637.74V87.73c0,10.75,2.42,17.12,12.14,17.12a34.61,34.61,0,0,0,9.52-1.11l.47,17.54c-3.48,1.36-9.84,2.55-17.36,2.55-8.81,0-16-3.19-20.27-7.83-4.94-5.28-7.1-13.94-7.1-24.93V51.24H601.93V33.83h13.21V5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M717.93,31.67c-31.42,0-46.38,24.69-46.38,47.32,0,26.82,18.22,44.84,48.69,44.84A99,99,0,0,0,738,122.31a9.22,9.22,0,0,1-3-16.6,92.42,92.42,0,0,1-11.76.69c-15.53,0-28.92-7.5-29.64-22.18h64.59a39.69,39.69,0,0,0,.88-9C759.13,57.4,749.84,31.67,717.93,31.67ZM693.58,68.14c1.19-8.55,7.52-21,23-21,17.56,0,20.73,14.9,20.66,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M752.43,112.19a8.22,8.22,0,0,1-3,6.34,8.88,8.88,0,0,1-1.06.76c-.17.1-.35.19-.53.28-.53.23-1.06.42-1.62.62h0a8.61,8.61,0,0,1-2,.25,8.13,8.13,0,0,1-2-.24,8.24,8.24,0,0,1-2.64-14.84,7.66,7.66,0,0,1,1.87-1l1-.28.07,0a9.18,9.18,0,0,1,1.67-.17,8.28,8.28,0,0,1,1.23.1c.24,0,.47.08.71.14A8.23,8.23,0,0,1,752.43,112.19Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c0440fbb3c6d7b2dd6e6f980cae5ccc3.svg";
export { ForwardRef as ReactComponent };